<template>
    <el-tooltip
        :content="$t.__('dashboard.cards.FiscalYearFooter.fiscal_year_start_date')"
        placement="bottom"
        v-if="fiscalDate"
    >
        <span class="dinlineb p-3">
            {{ $l10n.__('Depuis le %(fiscalDate)s', { fiscalDate: fiscalDate }) }}
        </span>
    </el-tooltip>
</template>
<script>
export default {
    props: {
        fiscalYearTimestamp: { type: Number, required: false },
    },
    computed: {
        fiscalDate() {
            if (this.fiscalYearTimestamp) {
                var date =
                    this.$store.state.corp.timeformat == 'dmy'
                        ? moment(this.fiscalYearTimestamp, 'X').format('DD/MM/YYYY')
                        : moment(this.fiscalYearTimestamp, 'X').format('MM/DD/YYYY');
                return date;
            }
        },
    },
};
</script>
